import { type ExceptionEvent, type TransportItem, TransportItemType } from '@grafana/faro-react'
import { initNaisAPMClient } from '@nais/apm/react'

// Temporary: "Script error." (Safari only) has no stack, so attach what was loaded to help find the source.
function withScriptErrorContext(item: TransportItem): TransportItem {
    if (item.type !== TransportItemType.EXCEPTION) return item
    const payload = item.payload as ExceptionEvent
    if (!payload.value?.startsWith('Script error')) return item

    const noCorsScripts = [...document.scripts]
        .filter((s) => s.src && s.crossOrigin === null && !s.src.startsWith(location.origin))
        .map((s) => s.src)
    const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined

    payload.context = {
        ...payload.context,
        noCorsScripts: noCorsScripts.join(' '),
        skyraLoaded: String(noCorsScripts.some((src) => src.includes('skyra'))),
        consentAnswered: String(document.cookie.includes('navno-consent=')),
        navigationType: navigation?.type ?? 'unknown',
        msSinceLoad: String(Math.round(performance.now())),
        visibility: document.visibilityState,
    }
    return item
}

// Tracing propagerer traceparent til alle *.nav.no-verter, og den headeren gjør de
// kryss-origin-kallene dekoratøren gjør (main-menu, ops-messages, auth) til preflight-kall.
// Dekoratøren svarer 404 på OPTIONS, så kallene blokkeres av CORS. Vi lar dem stå uinstrumentert.
const dekoratorenUrls = [
    /^https:\/\/www\.nav\.no\/dekoratoren/,
    /^https:\/\/dekoratoren[\w-]*\.(ekstern\.dev|intern\.dev)\.nav\.no/,
    /^https:\/\/cdn\.nav\.no\/personbruker\/nav-dekoratoren/,
]

// Kjører før hydrering, i motsetning til init fra en useEffect — så hydreringsfeil blir fanget.
// app, cluster og collector-URL kommer fra <NaisMetaTags /> i Decorator; bare disse to er kjent på byggetid.
initNaisAPMClient({
    namespace: 'arbeidsforhold',
    // Må matche bundlene som ligger på CDN-et, ellers peker en feil til feil build.
    version: process.env.NEXT_PUBLIC_APP_VERSION,
    tracing: true,
    beforeSend: withScriptErrorContext,
    faro: { ignoreUrls: dekoratorenUrls },
})
